import SelectBox from 'devextreme-react/select-box'
import { Button } from 'devextreme-react/button'
import { useAuth } from '../../contexts/auth'
import './select-dogovor.scss'
import StorageService from '../../services/storage.service'
import { useReqPopup } from '../../contexts/req-popup'
import { TextBox } from 'devextreme-react'
import React, { useEffect, useState } from 'react'
import {getDolgSum, getFinInfoSum, getImminentPays, getOverpaySum, getPeniSum, getTaxSum} from '../../api/dogovor'
import { verifyAccess, dogHasParameterMenu } from '../../utils/admin.utils'
import notify from "devextreme/ui/notify";
import {PopupTitleWithIcon} from "../popup-title-with-icon/popup-title-with-icon";
import {faFileLines} from "@fortawesome/free-solid-svg-icons";
import ScrollView from "devextreme-react/scroll-view";
import Popup from "devextreme-react/popup";
import { useLocation } from 'react-router-dom'

const finNumber = (value) => {
    if (typeof value === 'number' && !Number.isNaN(value)) return value
    if (typeof value === 'string' && value.trim() !== '' && !Number.isNaN(+value)) return +value
    return 0
}

const SelectDogovor = (props) => {

    const { dogovors, selectedDog, setSelectedDog } = useAuth() //, updateCountNotReads, updateCountVistSf
    const { openReqPopup } = useReqPopup()
    const location = useLocation()
    const sd_visible = props.visible //? 'block' : 'none'
    const all_visible = !props.all_visible
    const [sumDolg, setSumDolg] = useState(0)
    const [sumAvansDolg, setSumAvansDolg] = useState(0)
    const [visibleDebt, setVisibleDebt] = useState(true)
    const [finInfoSum, setFinInfoSum] = useState(null)
    const RENERGY = process.env.REACT_APP_NAME_ENV === 'renergy'
    const TES = process.env.REACT_APP_NAME_ENV === 'tatenergosbyt'
    const [visiblePop, setVisiblePop] = useState(false)
    const [parameterMenu, setParameterMenu] = useState("0")

    // ГП (2) и ФИКС (3): детализация во всплывашке на всех страницах, кроме /dogovor-actions
    const isGpOrFix = RENERGY && ['2', '3'].includes(String(parameterMenu))
    const isDogovorActionsPage = (location?.pathname || '').includes('dogovor-actions')
        || window.location.hash.includes('dogovor-actions')
    const showDetailPopup = isGpOrFix && !isDogovorActionsPage

    const formatMoney = (value) => (+(value || 0)).toLocaleString('ru', { style: "currency", currency: "RUB" })
    const formatToPay = (value) => formatMoney(Math.max(0, +(value || 0)))
    // «К оплате» приходит с бэкенда (for_pay_sum): из сумм документов вычтена переплата, не ниже нуля
    const payTotal = (fin) => fin?.for_pay_sum == null
        ? Math.max(0, finNumber(fin?.sum_dolg) + finNumber(fin?.sum_energy) + finNumber(fin?.sum_peni) + finNumber(fin?.sum_tax))
        : finNumber(fin.for_pay_sum)

    const onSelectDogovor = (e) => {
        let selectedDog = dogovors.find(dogovor => dogovor.kodDog === e.value)
        if (selectedDog) {
            StorageService.setLocalDogovor(selectedDog)
            setSelectedDog(selectedDog)
            //updateCountNotReads(selectedDog)
            //updateCountVistSf(selectedDog)
        }
    }

    useEffect(() => {
        // race after impersonation/login: selectedDog is null until user-dogovors loads
        if (!selectedDog) {
            setVisibleDebt(false)
            return
        }
        //const debtRoles = [3,4]
        const debtRoles = TES ? [3] : [3,4];
        setParameterMenu(selectedDog.parameter_menu)
        if (!verifyAccess(debtRoles, selectedDog)) {//(selectedDog ? selectedDog.roles : [])
            setVisibleDebt(false)
            return
        }
        (async function(){
            setVisibleDebt(true)
            const res = await getDolgSum(selectedDog.kodDog)
            if (res.isOk) {
                //const sumResult =  res.data.real2 + res.data.real0
                setSumDolg(res.data.real2)
                setSumAvansDolg(res.data.real0)
            } else {
                setSumDolg('-')
                setSumAvansDolg('-')
            }
            //setSumDolg(selectedDog.dolg)
        })()
    },[selectedDog, TES])

    useEffect(() => {
        if (!RENERGY || !selectedDog?.kodDog || !(dogHasParameterMenu(selectedDog, '2') || dogHasParameterMenu(selectedDog, '3'))) {
            setFinInfoSum(null)
            if (!TES) return
        }
        (async function () {
            const [resFinInfo, resOverpay, resTax, resPeni, resImminent] = await Promise.all([
                getFinInfoSum(selectedDog.kodDog),
                getOverpaySum(selectedDog.kodDog),
                getTaxSum(selectedDog.kodDog),
                getPeniSum(selectedDog.kodDog),
                getImminentPays(selectedDog.kodDog)
            ])

            const finData = resFinInfo.isOk ? (resFinInfo.data || {}) : {}
            if (!resFinInfo.isOk) notify(resFinInfo.message, 'error', 5000)

            setFinInfoSum({
                sum_dolg: finNumber(finData.sum_dolg),
                sum_energy: finNumber(finData.sum_energy),
                for_pay_sum: finData.for_pay_sum == null ? null : finNumber(finData.for_pay_sum),
                sum_overpay: resOverpay.isOk ? finNumber(resOverpay.data?.sum_overpay) : 0,
                sum_tax: resTax.isOk ? finNumber(resTax.data?.sum_tax) : 0,
                sum_peni: resPeni.isOk ? finNumber(resPeni.data?.sum_peni) : 0,
                sum_imminent: resImminent.isOk ? finNumber(resImminent.data?.sum_imminent) : 0,
            })
        })()
    }, [selectedDog, RENERGY, TES])

    const btnAddClick = () => {
        openReqPopup(true,1)
    }

    function capitalizeFirstLetter(val) {
        return String(val).charAt(0).toUpperCase() + String(val).slice(1);
    }

    function formatDate(d) {
        return d.slice(8,10) + '.' + d.slice(5,7) + '.' + d.slice(0,4);
    }

    function dateTatenergo(data) {
        return TES ? (` (${formatDate(data.datDog)}` + (data.datFin ? ` - ${formatDate(data.datFin)})`:`)`)) : ''
    }

    const renderField = (data) => {
        let visible = ((data && data.roles?.includes(3)) && (visibleDebt && data.dolg && data.dolg !== 0))
        return (
            <div className="select-dogovor-field-render">
                <TextBox
                    readOnly={true}
                    defaultValue={data ? ('№'+(data.ndog ? data.ndog : '') + ': ' + (data.name ? data.name : '') +
                            (data.statusDog ? ' (' + capitalizeFirstLetter(data.statusDog) + ')' : '') +
                            (visible ? ' (' + data.dolg?.toLocaleString('ru',{style:"currency", currency:"RUB"}) + ')':'')) +
                        dateTatenergo(data) : ''}
                />
            </div>
        );
    }
    function Item(data) {
        let visible  = ((data && data.roles?.includes(3)) && (visibleDebt && data.dolg && data.dolg !== 0))
        return (
            <div className="custom-item-wite-space-normal">
                {data ? ('№'+(data.ndog ? data.ndog : '') + ': ' + (data.name ? data.name : '') +
                        (data.statusDog ? ' (' + capitalizeFirstLetter(data.statusDog) + ')' : '') +
                        ((visible) ? ' (' + data.dolg?.toLocaleString('ru',{style:"currency", currency:"RUB"}) + ')' : '')) +
                    dateTatenergo(data) : ''}
            </div>
        );
    }
    return (
        <>
            { sd_visible &&
                <div className={!all_visible ? '' : 'select-dogovor content-block dx-card responsive-paddings big-input'}>
                    <div className={all_visible ? 'select-dogovor-toolbar' : ''}>
                        <div className={!all_visible ? '' : 'bd-container-body'}>
                            <SelectBox className='w-100'
                                       labelMode={'outside'}
                                       stylingMode={'outlined'}
                                       label={'Договор'}
                                       dataSource={dogovors}
                                       displayExpr="name"//{(itemData, itemIndex, itemElement)=>{return '№'+itemData.ndog+': '+itemData.name}}//"name"
                                       valueExpr="kodDog"
                                       defaultValue={selectedDog ? selectedDog.kodDog : null}
                                       value={selectedDog ? selectedDog.kodDog : null}
                                //itemTemplate={(itemData, itemIndex, itemElement)=>{itemElement.append('№'+itemData?.ndog +  ': ' + itemData.name + ((visibleDebt && itemData.dolg && itemData.dolg !== 0) ? ' (--' + itemData.dolg.toLocaleString('ru',{style:"currency", currency:"RUB"}) + ')' : ''));}}
                                       placeholder="Выберите договор.."
                                       onValueChanged={onSelectDogovor}
                                       noDataText="У Вас нет подключенных договоров"
                                       fieldRender={renderField}
                                       itemRender={Item}
                                //dropDownOptions={{resizeEnabled: true, minWidth: '200px' }} с этим перестало работать переключение
                                       searchEnabled={true}
                                       searchExpr={['name','ndog']}
                                       searchMode={"contains"}
                            >
                            </SelectBox>
                        </div>
                        {all_visible &&
                            <div className="bd-container-sidebar">
                                <Button className={'big-button'} icon="add" type={'default'} onClick={btnAddClick}/>
                            </div>
                        }
                    </div>


                    {((visibleDebt && all_visible && !RENERGY) || (RENERGY && ['1'].includes(String(parameterMenu)))) &&
                        <div className='mt-3'>
                            <h5>{TES ? <>Задолженность по итогу:</>:<>Задолженность:</>} <a href={"#/debt"}>{sumDolg >= 0 ? sumDolg?.toLocaleString('ru',{style:"currency", currency:"RUB"}):(0).toLocaleString('ru',{style:"currency", currency:"RUB"})}</a></h5>
                            <h5>{TES ? <>Задолженность по промежуточным платежам:</>:<>Обязательства по авансовым платежам::</>} <a href={"#/debt"}>{sumAvansDolg?.toLocaleString('ru',{style:"currency", currency:"RUB"})}</a></h5>
                            {TES &&
                                <>
                                    <h5>Задолженность по пеням: <a href={"#/debt"}>{formatMoney(finInfoSum?.sum_peni)}</a></h5>
                                    <h5>Госпошлина по решению суда: <a href={"#/debt"}>{formatMoney(finInfoSum?.sum_tax)}</a></h5>
                                    <div style={{maxWidth: '600px'}}><h5 className=''>Переплата: <a
                                        href={"#/debt"}>{formatMoney(finInfoSum?.sum_overpay)} </a><small className='font-weight-normal'>
                                        <sup>*</sup>Внимание: Наличие переплаты не освобождает вас от оплаты авансовых
                                        платежей и
                                        задолженности. Для погашения переплатой сумм долга неоплаченных документов, вам
                                        необходимо направить письмо в {selectedDog?.filialName}</small></h5></div>
                                </>
                            }
                        </div>
                    }



                    {showDetailPopup && finInfoSum &&
                        <div className={'mt-3'}>
                            <strong>
                                <h5>К оплате: {formatToPay(payTotal(finInfoSum))}</h5>
                                <a className="dashed" id="link1" href='/' onClick={(e) => {
                                    setVisiblePop( true );
                                    e.preventDefault()
                                }}>Подробная детализация</a></strong>
                            <Popup
                                hideOnOutsideClick={true}
                                visible={visiblePop}
                                onHiding={() => {
                                    setVisiblePop( false )
                                }}
                                maxWidth='500px'
                                maxHeight={'90%'}
                                height={'auto'}
                                title="Детализация"
                                titleRender={() => PopupTitleWithIcon( faFileLines, "Детализация", () => {
                                    setVisiblePop( false )
                                } )}
                            >
                                <ScrollView className="big-input popupWithUploader" width='100%' height='100%'>
                                    <div className="px-3">
                                        <h5>К оплате: {formatToPay(payTotal(finInfoSum))}</h5>
                                        <p className="my-1"><b>Электроэнергия:</b> {formatMoney(finInfoSum.sum_dolg)}</p>
                                        <p className="my-1"><b>Пени:</b> {formatMoney(finInfoSum.sum_peni)}</p>
                                        <p className="my-1"><b>Предстоящие платежи:</b> {formatMoney(finInfoSum.sum_energy)}</p>
                                        <p className="my-1"><b>Госпошлина:</b> {formatMoney(finInfoSum.sum_tax)}</p>
                                    </div>
                                </ScrollView>
                            </Popup>
                        </div>}
                </div>

            }
        </>
    )
}

export default SelectDogovor
